import React, { useContext } from 'react';
import { GestureResponderEvent, StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';
import { ActivityIndicator, Text, ThemeContext } from '..';

/*eslint-disable react-native/no-unused-styles*/
const getStyles = (theme: Theme): Record<string, Record<string, string | number>> =>
  StyleSheet.create({
    container: {
      justifyContent: 'center',
      alignItems: 'stretch',
      backgroundColor: 'transparent',
    },
    gradient: {
      height: 45,
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: theme.buttons.commonStyle.borderRadius,
    },
    text: {
      textAlign: 'center',
      fontSize: 16,
      textTransform: theme.buttons.commonStyle.textTransform,
    },
  });

type ButtonType = 'PRIMARY' | 'CANCEL' | 'SUCCESS' | 'DEFAULT';

interface GradientButtonProps {
  buttonType?: ButtonType;
  disabled?: boolean;
  loading?: boolean;
  onPress?: (event: GestureResponderEvent) => void;
  style?: ViewStyle;
  text: string;
  textStyle?: ViewStyle;
}

export const GradientButton = ({
  buttonType = 'PRIMARY',
  disabled,
  loading = false,
  onPress,
  style,
  text,
  textStyle,
}: GradientButtonProps): React.JSX.Element=> {
  const theme = useContext(ThemeContext);
  const styles = getStyles(theme);

  const onPressTouchable = disabled ? undefined : onPress;
  const textColor = theme.buttons[buttonType].textColor;

  return (
    <TouchableOpacity
      onPress={onPressTouchable}
      style={[styles.container, style]}
      disabled={disabled || loading}
      activeOpacity={0.7}
    >
      {loading ? (
        <ActivityIndicator color={textColor} />
      ) : (
        <Text style={[styles.text, { color: textColor }, textStyle]}>{text}</Text>
      )}
    </TouchableOpacity>
  );
};
